module.exports = __webpack_public_path__ + "static/media/down.472f10d7.svg";